module.exports = __webpack_public_path__ + "img/loginScreen.0974a439.png";